import {URL_API_BOLETAS} from '@/config';
import * as AwsSigningUtils from '@/library/utils/aws-signing';
import * as EnvVarsUtils from '@/library/utils/env-vars';

// Recuperar valores de entorno
// 19-jul-24 se agrega fallback
// const URL_BASE = URL_API_BOLETAS || EnvVarsUtils.getEnvVar('URL_API_BOLETAS');

// Funciones
export const emisoresUsuario = function(usuario, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_API_BOLETAS}/api/info-contribuyente/emisores-usuario/${usuario}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};

export const infoEmisorUsuario = function(contribuyente, usuario, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_API_BOLETAS}/api/info-contribuyente/info-emisor-usuario/${contribuyente}/${usuario}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};

export const infoReceptor = function(contribuyente, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_API_BOLETAS}/api/info-contribuyente/info-receptor/${contribuyente}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};
